import React from 'react';
import DataTable from '../../components/nucleus/DataTable';
import { SHELVES, shelfOf } from '../../components/nucleus/shelves';
import { priceOf, shortPrice } from '../apps/appsData';
import { PluginFace } from '../../components/nucleus/faces';
import { verifiedWord } from './data/words';
import { asksLine, asksCounts } from './data/lists';
import { dateOf } from '../../nucleus/format';
import './PluginsSection.css';

// THE PLUGIN STORE, as rows: the one table (DataTable), like the Apps board.
// Each plugin not set up here: its category, whether ofSelf verified it, who
// made it, its price, what it asks for, when it was listed, and Set up at its
// end. A row opens the plugin; a right-click offers its acts. (My plugins is
// one list, PluginTree.js.)

/** A plugin's small face in a row: the one PluginFace (its logo, else the glyph). */
export function PluginMark({ logo = null, size = 24 }) {
    return <PluginFace size={size} logo={logo} />;
}

const when = (iso) => (iso ? new Date(iso).getTime() : null);
const amount = (text) => {
    const n = parseFloat(String(text || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(n) ? n : null;
};
export const shelfWord = (p) => SHELVES.find((s) => s.id === shelfOf(p.plugin))?.label || null;
const PLUGIN_COLUMN = {
    id: 'plugin', label: 'Plugin', lock: true, min: 180, grow: 2, className: 'plugins-table__name', value: (p) => p.name,
    cell: (p) => <><PluginMark logo={p.logo} /><span className="plugins-table__word">{p.name}</span></>,
};

/** Every plugin in the store, as a table: A to Z. */
export function PluginStoreTable({ items, openId, onOpen, actionsOf, onSetUp, held = null }) {
    const asksRank = (p) => { const a = asksCounts(p); return a.reads + a.writes + a.outside; };
    const columns = [
        PLUGIN_COLUMN,
        { id: 'category', label: 'Category', min: 90, grow: 0.6, keep: 5, value: shelfWord, cell: (p) => shelfWord(p) || '—' },
        { id: 'verified', label: 'Verified', min: 120, grow: 0, keep: 2, value: (p) => (p.verified ? 1 : 0),
          cell: (p) => (p.verified
              ? <span className="plugins-table__verified">{verifiedWord(true)}</span>
              : <span className="plugins-table__quiet">{verifiedWord(false)}</span>) },
        { id: 'made', label: 'Made by', min: 110, grow: 0.8, keep: 6, value: (p) => p.madeBy, cell: (p) => p.madeBy || '—' },
        { id: 'price', label: 'Price', num: true, min: 72, grow: 0, keep: 4, value: (p) => (priceOf(p.plugin) ? amount(priceOf(p.plugin)) : 0),
          cell: (p) => (priceOf(p.plugin) ? shortPrice(priceOf(p.plugin)) : 'Free') },
        { id: 'asks', label: 'It asks for', min: 150, grow: 1.2, keep: 3, className: 'plugins-table__asks', value: asksRank, cell: asksLine },
        { id: 'listed', label: 'Listed', min: 96, grow: 0, keep: 7, asc: false, value: (p) => when(p.listed), cell: (p) => dateOf(p.listed) || '—' },
        // SET UP, at the row's end: the row's one act (the row itself opens the plugin)
        onSetUp && { id: 'setup', label: '', lock: true, min: 92, grow: 0,
          cell: (p) => (
              <span className="plugins-table__act" title={held || undefined}>
                  <button type="button" className="plugins-setup-act" disabled={!!held} aria-label={`Set up ${p.name}`}
                      onClick={(e) => { e.stopPropagation(); onSetUp(p); }} onKeyDown={(e) => e.stopPropagation()}>
                      Set up
                  </button>
              </span>
          ) },
    ].filter(Boolean);
    return (
        <DataTable
            id="plugins-store" label="Plugin store" columns={columns} rows={items} keyOf={(p) => p.id} fit
            sort={{ id: 'plugin', dir: 'asc' }} currentKey={openId} onOpen={onOpen} actionsOf={actionsOf}
        />
    );
}
